import React, { useEffect } from "react";
import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
gsap.registerPlugin(MorphSVGPlugin);

const Two = () => {
  useEffect(() => {
    gsap.set("#ring-two-path", { autoAlpha: 0 });
    gsap.set("#ring-two-text", {
      autoAlpha: 0,
      scale: 0,
      transformOrigin: "center center",
    });
    gsap.set("#ring2-circ-before", {
      scale: 0,
      transformOrigin: "center center",
    });
    gsap.to("#int2", { y: 10, yoyo: true, repeat: -1, delay: 0.3 });
  }, []);

  const drawRing = () => {
    gsap.to(".ring2-before", { duration: 1, morphSVG: ".ring2-after" });
    gsap.to("#ring-two-text", {
      autoAlpha: 1,
      duration: 1,
      scale: 0.8,
      transformOrigin: "center center",
      delay: 0.3,
    });
  };

  const hoverRing = () => {
    // gsap.to('#ring2-circ-before',{fill: '#fff',scale: 1,transformOrigin: 'center center'})
    gsap.to(".ring2-before", { duration: 1, morphSVG: ".ring2-after" });
    gsap.to("#ring-two-text", {
      autoAlpha: 1,
      duration: 1,
      scale: 0.8,
      transformOrigin: "center center",
      delay: 0.3,
    });
  };

  const leaveRing = () => {
    gsap.to("#ring2-circ-before", {
      fill: "#000",
      scale: 0,
      transformOrigin: "center center",
    });
  };

  return (
    <svg
      id="int2"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 255.4 255.4"
      style={{ enableBackground: "new 0 0 255.4 255.4" }}
      onMouseEnter={hoverRing}
      onMouseLeave={leaveRing}
    >
      <g id="Layer_1">
        <g>
          <g>
            <path
              className="ring2-before"
              id="ring2-circ-before"
              style={{ fill: "#000000" }}
              d="M127.7,10c31.4,0,61,12.2,83.2,34.5c22.2,22.2,34.5,51.8,34.5,83.2s-12.2,61-34.5,83.2
				c-22.2,22.2-51.8,34.5-83.2,34.5s-61-12.2-83.2-34.5C22.2,188.7,10,159.1,10,127.7s12.2-61,34.5-83.2C66.7,22.2,96.3,10,127.7,10
				 M127.7,0C57.2,0,0,57.2,0,127.7s57.2,127.7,127.7,127.7s127.7-57.2,127.7-127.7S198.2,0,127.7,0L127.7,0z"
            />
          </g>
        </g>
        <g>
          <path
            className="ring2-before"
            style={{ fill: "#F6B74B" }}
            d="M86.2,88.6c5.5-7.2,15.8-17.5,34.7-17.5c21.2,0,34.4,13.3,34.4,32.8c0,12.4-6.3,21-14.6,29.7
			L119,156.1h38.8v18.3H90.7v-15.3l35.9-36.8c5.4-5.4,8.3-11,8.3-17.4c0-8.8-6.2-15.2-15.5-15.2c-9.6,0-15.4,5.2-20.6,11.2
			L86.2,88.6z"
          />
        </g>
      </g>
      <g id="Layer_2">
        <g>
          <path
            className="ring2-after"
            style={{ fill: "#F6B74B" }}
            id="ring-two-path"
            d="M127.7,10c31.4,0,61,12.2,83.2,34.5c22.2,22.2,34.5,51.8,34.5,83.2s-12.2,61-34.5,83.2
				c-22.2,22.2-51.8,34.5-83.2,34.5s-61-12.2-83.2-34.5C22.2,188.7,10,159.1,10,127.7s12.2-61,34.5-83.2C66.7,22.2,96.3,10,127.7,10
				 M127.7,0C57.2,0,0,57.2,0,127.7s57.2,127.7,127.7,127.7s127.7-57.2,127.7-127.7S198.2,0,127.7,0L127.7,0z"
          />
        </g>
        <path
          className="ring2-after"
          style={{ fill: "#FFFFFF" }}
          id="ring-two-text"
          d="M39.1,113.1c0,7.1-5.2,12.3-12.5,12.3s-12.5-5.2-12.5-12.3c0-7.1,5.2-12.3,12.5-12.3
		S39.1,106,39.1,113.1z M19,113.1c0,4.6,3.2,7.8,7.5,7.8c4.4,0,7.5-3.2,7.5-7.8s-3.2-7.8-7.5-7.8C22.2,105.3,19,108.5,19,113.1z
		 M52.6,125h-5.1L41,108.5h4.8l4.3,11.8l4.3-11.8H59L52.6,125z M76.5,116.7c0,0.5,0,1.1-0.1,1.5H64.7c0.5,2.4,2.1,3.4,4.2,3.4
		c1.4,0,3-0.6,4.2-1.6l2.6,2.9c-1.9,1.7-4.2,2.5-7,2.5c-5,0-8.5-3.4-8.5-8.6c0-5.2,3.4-8.7,8.3-8.7
		C73.2,108.1,76.5,111.6,76.5,116.7z M64.8,115.2h7.3c-0.4-2.1-1.7-3.3-3.6-3.3C66.4,111.9,65.2,113.2,64.8,115.2z M91.4,108.4
		l-0.7,4.4c-0.7-0.3-1.8-0.5-2.7-0.5c-2.1,0-3.5,1.3-3.5,3.7v9h-4.4v-16.5h4.3v1.8c1-1.5,2.6-2.2,4.6-2.2
		C90,108.1,90.8,108.2,91.4,108.4z M113.3,120.1l3.5-11.6h4.6l-5.6,16.5h-5.1l-3.7-11.1l-3.6,11.1h-5l-5.6-16.5h4.7l3.5,11.5
		l3.7-11.5h4.7L113.3,120.1z M128.7,110.3c1.2-1.6,2.9-2.2,4.7-2.2c3.7,0,6.4,2.6,6.4,6.4V125h-4.4v-9.1c0-2.4-1.2-3.7-3.2-3.7
		c-1.9,0-3.5,1.2-3.5,3.7v9h-4.4v-24.5h4.4V110.3z M159.7,116.7c0,0.5,0,1.1-0.1,1.5h-11.7c0.5,2.4,2.1,3.4,4.2,3.4
		c1.4,0,3-0.6,4.2-1.6l2.6,2.9c-1.9,1.7-4.2,2.5-7,2.5c-5,0-8.6-3.4-8.6-8.6c0-5.2,3.4-8.7,8.3-8.7
		C156.4,108.1,159.6,111.6,159.7,116.7z M147.9,115.2h7.3c-0.4-2.1-1.7-3.3-3.6-3.3C149.5,111.9,148.3,113.2,147.9,115.2z
		 M167.7,125h-4.4v-24.5h4.4V125z M199.1,114.5V125h-4.4v-9.1c0-2.4-1.2-3.7-3.2-3.7c-1.9,0-3.5,1.2-3.5,3.7v9h-4.4v-9.1
		c0-2.4-1.2-3.7-3.2-3.7c-1.9,0-3.5,1.2-3.5,3.7v9h-4.4v-16.5h4.3v1.9c1.2-1.8,3-2.4,4.8-2.4c2.4,0,4.3,1.1,5.4,2.8
		c1.3-2.1,3.4-2.8,5.6-2.8C196.4,108.1,199.1,110.7,199.1,114.5z M218.9,116.7c0,0.5,0,1.1-0.1,1.5h-11.7c0.5,2.4,2.1,3.4,4.2,3.4
		c1.4,0,3-0.6,4.2-1.6l2.6,2.9c-1.9,1.7-4.2,2.5-7,2.5c-5,0-8.6-3.4-8.6-8.6c0-5.2,3.4-8.7,8.3-8.7
		C215.6,108.1,218.9,111.6,218.9,116.7z M207.2,115.2h7.3c-0.4-2.1-1.7-3.3-3.6-3.3C208.8,111.9,207.5,113.2,207.2,115.2z
		 M234.3,110.2v-9.7h4.4V125h-4.3v-1.8c-1.1,1.3-2.7,2.2-4.9,2.2c-4.5,0-8-3.7-8-8.7s3.4-8.7,8-8.7
		C231.7,108.1,233.2,109,234.3,110.2z M226,116.8c0,2.5,1.6,4.5,4.2,4.5c2.5,0,4.2-1.9,4.2-4.5s-1.7-4.5-4.2-4.5
		C227.7,112.2,226,114.2,226,116.8z M92.8,165.8h-4.3V164c-1.1,1.3-2.7,2.2-4.9,2.2c-4.5,0-8-3.7-8-8.7s3.4-8.7,8-8.7
		c2.3,0,3.8,0.9,4.9,2.3v-1.8h4.3V165.8z M80.1,157.6c0,2.5,1.6,4.5,4.2,4.5c2.5,0,4.2-1.9,4.2-4.5s-1.7-4.5-4.2-4.5
		C81.7,153,80.1,155,80.1,157.6z M109.1,151.2v-1.8h4.4v15.1c0,5.3-3.5,8.5-8.9,8.5c-2.6,0-5.4-0.7-7.2-2l1.6-3.6
		c1.6,1.1,3.5,1.7,5.4,1.7c2.8,0,4.7-1.5,4.7-4.4v-1.2c-1.1,1.4-2.8,2.2-5.1,2.2c-4,0-7.6-3.3-7.6-8.4c0-5.1,3.6-8.4,7.6-8.4
		C106.3,148.9,108,149.8,109.1,151.2z M101,157.3c0,2.4,1.6,4.3,4.1,4.3c2.5,0,4.1-1.9,4.1-4.3c0-2.5-1.7-4.3-4.1-4.3
		C102.6,153,101,154.9,101,157.3z M133.4,157.5c0,0.5,0,1.1-0.1,1.5h-11.7c0.5,2.4,2.1,3.4,4.2,3.4c1.4,0,3-0.6,4.2-1.6l2.6,2.9
		c-1.9,1.7-4.2,2.5-7,2.5c-5,0-8.5-3.4-8.5-8.6s3.4-8.7,8.3-8.7C130.2,148.9,133.4,152.4,133.4,157.5z M121.7,156h7.3
		c-0.4-2.1-1.7-3.3-3.6-3.3C123.3,152.7,122.1,154,121.7,156z M152.6,155.3v10.5h-4.4v-9.1c0-2.4-1.2-3.7-3.2-3.7
		c-1.9,0-3.5,1.2-3.5,3.7v9h-4.4v-16.5h4.3v1.9c1.2-1.8,3-2.4,4.8-2.4C150,148.9,152.6,151.5,152.6,155.3z M168.9,153.3h-6v6
		c0,2.1,1.1,2.8,2.5,2.8c1.1,0,2.2-0.5,3.1-1.1l1.6,3.5c-1.4,1-3.1,1.7-5.5,1.7c-4.1,0-6.2-2.3-6.2-6.6v-6.4h-3.2v-3.9h3.2v-4.9h4.4
		v4.9h6V153.3z M184.7,153.9c-1.3-0.6-3.4-1.3-5.3-1.3c-1.7,0-2.5,0.6-2.5,1.5c0,1,1.2,1.2,2.7,1.4l1.5,0.2c3.6,0.5,5.6,2.1,5.6,4.9
		c0,3.4-2.8,5.6-7.6,5.6c-2.2,0-5.2-0.4-7.3-1.9l1.8-3.4c1.4,0.9,3.1,1.6,5.6,1.6c2.1,0,3-0.6,3-1.5c0-0.8-0.8-1.2-2.7-1.5l-1.3-0.2
		c-3.8-0.5-5.7-2.2-5.7-5c0-3.4,2.6-5.4,7-5.4c2.6,0,4.7,0.5,6.9,1.6L184.7,153.9z"
        />
      </g>
    </svg>
  );
};

export default Two;
